export const build = { date:"2026-05-12.1247", stage:"alpha" }
